module.exports = __webpack_public_path__ + "static/img/water_quality_turbidity.bf94872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/water_quality_turbidity.png
// module id = Q/a3
// module chunks = 1